/**
 * GlobalEmailComposer
 * -------------------
 * Rendert die eigentliche EmailComposerV2-Komponente EINMAL im App-Layout.
 * Steuert sich per `EmailComposerContext` — dadurch bleibt der State
 * (Betreff, Body, Anhänge) beim Wechseln zwischen Tabs/Routen erhalten.
 */
import EmailComposerV2 from './EmailComposerV2';
import { useEmailComposer } from '../../contexts/EmailComposerContext';

export default function GlobalEmailComposer() {
  const ctx = useEmailComposer();
  if (!ctx) return null;
  const { isOpen, composerProps, close } = ctx;

  return (
    <EmailComposerV2
      key={composerProps?.__sessionId || 'composer'}
      open={isOpen}
      onClose={() => {
        try { composerProps?.onClose?.(); } catch { /* ignore */ }
        close();
      }}
      onSent={(...args) => {
        try { composerProps?.onSent?.(...args); } catch { /* ignore */ }
        close();
      }}
      {...(composerProps || {})}
    />
  );
}
